import './CollectibleProgress.css';
import collectibleIcon from '../../components/atomic/icons/stat_icons/collectible_icon.png';
import { CollectibleCountText } from './CollectibleCountText';

export type CollectibleProgressProps = {
  /** Collected items (Figma default 53). */
  collected?: number;
  /** Total items (Figma default 60). */
  total?: number;
};

/** Figma collectible HUD — icon (130:21334) + count (130:21291). */
export function CollectibleProgress({
  collected = 53,
  total = 60,
}: CollectibleProgressProps) {
  return (
    <>
      <img
        className="collectible-progress__icon"
        src={collectibleIcon}
        alt=""
        draggable={false}
        aria-hidden
      />
      <CollectibleCountText
        className="collectible-progress__count"
        collected={collected}
        total={total}
      />
    </>
  );
}
